<ion-header>
    <ion-toolbar>
        <ion-title>{{'STATIC_LIVE_VOTING' | translate}}</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>

    <ng-container *ngFor="let voting of liveVotings;let i = index">

        <h2 *ngIf="i == 0 || voting.title != liveVotings[i -1].title">{{ voting.title }}</h2>

        <div class="voting-item">

            <div class="voting-detail">
                <ion-row>
                    <ion-col size="12"
                             size-md="6">
                        <h3>
                            <svg-icon [applyClass]="true"
                                      src="/assets/icons/ico-hashtag.svg"
                                      class="icon fill-light">
                            </svg-icon>
                            {{ voting.question }}
                        </h3>
                    </ion-col>
                    <ion-col *ngIf="!voting.participant_id">
                        <ion-button (click)="showLiveVoting(voting.id)">
                            {{'STATIC_LIVE_VOTING_JOIN' | translate}}
                        </ion-button>
                    </ion-col>
                </ion-row>
            </div>
        </div>
    </ng-container>

</ion-content>